import client from './client';

export default {
  postNewOffer(params) {
    return client.post('/trade_offers/posted_offers/post_new_offer')
      .query(params)
      .end();
  },

  fetchPostedOffers(params) {
    return client.get('/trade_offers/posted_offers/index')
      .query(params)
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/postedOffersApi.js